import moment from 'moment';

export const Constants = {
  FIRST_DAY: moment.utc('1970-01-05')
};